import ReplyComment from "./reply-comment.component";

export default ReplyComment;
